import { Creatable, Deletable, Editable } from '@/types/model.types';
import { PlatformCreateDevice } from '@data/_generated-api/platform-api/models/platform-create-device';
import { PlatformUpdateDevice } from '@data/_generated-api/platform-api/models/platform-update-device';
import { Form } from '@common/formly/form.decorator';
import { defaultDeviceFormConfig } from '@/app/platform/platform-data/models/device.entity.form-config';
import { DeviceData } from '@/app/platform/platform-shared/models/device-data';
import { DeviceType } from '@/app/platform/platform-shared/enum/device-type';

/**
 * @inheritDoc
 */
@Form('create', defaultDeviceFormConfig)
@Form('edit', defaultDeviceFormConfig)
export class DeviceEntity
  extends DeviceData
  implements Creatable<PlatformCreateDevice>, Editable<PlatformUpdateDevice>, Deletable<string>
{
  get creationModel(): PlatformCreateDevice {
    return {
      name: this.name,
      pcName: this.pcName,
      type: Number(this.type),
      defaultUserAccountId: this.defaultUserAccountId
    };
  }

  get deleteKey(): string {
    return this.id;
  }

  get editingModel(): PlatformUpdateDevice {
    return {
      id: this.id,
      name: this.name,
      pcName: this.pcName,
      type: Number(this.type),
      defaultUserAccountId: this.defaultUserAccountId
    };
  }

  static createDefault(id?: string): DeviceEntity {
    return new DeviceEntity(id ?? '', {}, '', '', DeviceType.Unknown, undefined);
  }
}
